import { cn } from '@/lib/utils';
import { Badge } from '../Badge';

export interface TabItem {
    id: string;
    label: string;
    count?: number;
    disabled?: boolean;
}

interface TabsProps {
    tabs: TabItem[];
    activeTab: string;
    onTabChange: (tabId: string) => void;
}

export function Tabs({ tabs, activeTab, onTabChange }: TabsProps) {
    return (
        <div className="flex flex-row items-center h-7 overflow-x-auto scrollbar-hide">
            {tabs.map((tab) => {
                const isActive = activeTab === tab.id;
                return (
                    <button
                        key={tab.id}
                        type="button"
                        disabled={tab.disabled}
                        onClick={() => onTabChange(tab.id)}
                        className={cn(
                            'flex shrink-0 flex-row items-center justify-center h-7 px-3 rounded-[4px] transition-colors',
                            tab.disabled &&
                                'cursor-not-allowed text-grey-500 hover:text-grey-500',
                            isActive && !tab.disabled
                                ? 'bg-grey-500 text-white-100'
                                : !tab.disabled &&
                                      'text-grey-300 hover:text-white-100',
                        )}
                    >
                        <span className="flex flex-row items-baseline gap-1.5">
                            <span className="text-[14px] leading-5 font-normal">
                                {tab.label}
                            </span>
                            {tab.count !== undefined && (
                                <Badge
                                    variant="number"
                                    animated
                                    value={tab.count}
                                    className="shrink-0 -translate-y-px"
                                />
                            )}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
